"use client";

import { useState, useRef, useEffect } from "react";
import "../assets/css/otp.min.css";
import { useNavigate } from "react-router-dom";
import TwoFactorAuthImage from './../assets/img/Two-factor-authentication-pana.svg';
import Cookies from "js-cookie";
import { toast } from "react-toastify";


export default function OtpVerified () {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState(["", "", "", ""]);

    const [isLoading, setIsLoading] = useState(false);
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);

    // OTP input refs
    const otpRefs = [useRef(), useRef(), useRef(), useRef()];

    // Static OTP for verification
    const STATIC_OTP = "1234";

    // Timer effect
    useEffect(() => {
        let interval = null;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((timer) => timer - 1);
            }, 1000);
        } else if (timer === 0) {
            setCanResend(true);
        }
        return () => clearInterval(interval);
    }, [timer]);



    // Handle OTP input change
    const handleOtpChange = (index, value) => {
        if (value.length > 1) return; // Prevent multiple characters

        const newOtp = [...otp];
        newOtp[index] = value;

        setOtp(newOtp);

        // Auto-focus next input
        if (value && index < 3) {
            otpRefs[index + 1].current.focus();
        }
    };

    // Handle OTP key down
    const handleOtpKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            otpRefs[index - 1].current.focus();
        }
    };

    // Handle OTP verification
    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        const enteredOtp = otp.join("");

        if (enteredOtp.length !== 4) {
            alert("Please enter complete OTP");
            return;
        }

        setIsLoading(true);

        try {
            const email = Cookies.get("UserEmail"); // Get email from cookies
            if (!email) {
                alert("Email not found. Please try again.");
                return;
            }

            const formData = new FormData();
            formData.append("email", email);
            formData.append("otp", enteredOtp);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_verify_otp.php", {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success || result.status === "success") {
                toast.success("OTP verified successfully!");
                navigate('/log-in'); // Navigate to login page or reset password page
            } else {
                toast.error(result.message || "Invalid OTP. Please try again.");
                setOtp(["", "", "", ""]);
                if (otpRefs[0]?.current) {
                    otpRefs[0].current.focus();
                }
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            alert("Failed to verify OTP. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    // Handle resend OTP
    const handleResendOtp = () => {
        setTimer(60);
        setCanResend(false);
        setOtp(["", "", "", ""]);
        otpRefs[0].current.focus();
        alert("New OTP sent!");
    };

    // Go back to previous step
    const handleGoBack = () => {
        navigate('/sign-up');
    };

    return (
        <div className="forgot-password-wrapper">
            <div className="full-container">
                <img src={TwoFactorAuthImage} alt="log in page" style={{
                    height: "600px",
                    "@media (min-width: 992px)": {
                        marginLeft: "50px"
                    }
                }} />
            </div>
            <div className="full-container mt-5">
                <div className="forgot-password-container">
                    <div className="step-content">
                        <div className="step-header">
                            <h2 className="step-title">Enter OTP</h2>
                            <p className="step-subtitle">
                                We've sent a 4-digit code to <strong>{email}</strong>
                            </p>
                            {/* <p className="otp-hint">
                                Current OTP: <strong>1234</strong>
                            </p> */}
                        </div>

                        <form onSubmit={handleOtpSubmit} className="forgot-form">
                            <div className="otp-container">
                                <label className="field-label">Enter 4-Digit OTP</label>
                                <div className="otp-inputs">
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={otpRefs[index]}
                                            type="text"
                                            maxLength="1"
                                            className="otp-input"
                                            value={digit}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="timer-section">
                                {!canResend ? (
                                    <p className="timer-text">Resend OTP in {timer}s</p>
                                ) : (
                                    <button type="button" className="resend-button" onClick={handleResendOtp}>
                                        Resend OTP
                                    </button>
                                )}
                            </div>

                            <button type="submit" className="btn-signin rounded-3 full-width" disabled={isLoading}>
                                {isLoading ? "Verifying..." : "Verify OTP"}
                            </button>

                            <div className="form-footer">
                                <button type="button" className="link-text" onClick={handleGoBack}>
                                    ← Change Email
                                </button>
                            </div>
                        </form>
                    </div>



                </div>
            </div>
        </div>
    );
}
